import axiosInstance from "../../../http-common";
import { v4 } from "uuid";
import { logout_if_403 } from "../../../util";
import { PO_Backlog_Service } from "../../../redux/po_backlog/po_backlog.services";

export const getErrorMessage = (error) => {
  if (error instanceof Error) return error.message;
  return String(error);
};

// to load initial data
export const load_sample_collector_data_from_backend = async (
  data,
  setData,
  tabName
) => {
  try {
    const result = await axiosInstance.get(
      `v1/qc/open_po_new/${tabName}/?user=sample_collector`
    );
    console.log(result);
    if (result.data) {
      const tableData = result?.data?.data?.map((item) => ({
        ...item,
        id: v4(),
      }));
      if (
        result["data"]?.["data"] &&
        setData &&
        typeof setData === "function"
      ) {
        setData(tableData);
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  }
};

// // to edit
export const edit_sample_collector_schedule = async (updatedRow, category) => {
  try {
    const { ...update_fields } = updatedRow;
    const data = JSON.stringify({
      ...update_fields,
    });
    console.log({ update_fields });
    const response = await axiosInstance.patch(
      `/v1/qc/open_po_new/${category}/`,
      data
    );
    const result = response.data.status;
    console.log({ result });
    if (
      result === "success"
    ) return true;
    else return false;
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
  }
};

export const edit_sample_receiver_schedule = async (updatedRow, category) => {
  // console.log(updatedRow, category);
  const { ...update_fields } = updatedRow;
  let receiving_date_by_qc = null;
  if (update_fields.receiving_date_by_qc instanceof Date) {
    receiving_date_by_qc = update_fields.receiving_date_by_qc.toISOString();
  }
  // console.log(receiving_date_by_qc, updatedRow);

  const data = JSON.stringify({
    ...update_fields,
    receiving_date_by_qc,
  });
  console.log(data);
  const response = await axiosInstance.patch(
    `/v1/qc/open_po_new/${category}/`,
    data
  );
  const result = response.data.status;
  // const result = true;
  console.log({ result });
  if (result === "success") return true;
  else return false;
};

// to fetch sample types
export const fetchSampleType = async () => {
  try {
    const client_id = localStorage.getItem("client_id");
    if (client_id) {
      const result = await PO_Backlog_Service.sample_types_get();
      // console.log(result);
      if (Array.isArray(result?.data?.data)) {
        return result?.data?.data;
      } else if (typeof result?.data?.data === "object") {
        const extractedStrings = [];
        const tempData = result?.data?.data;
        for (const key in tempData) {
          if (tempData.hasOwnProperty(key)) {
            const innerArray = tempData[key];
            for (const item of innerArray) {
              extractedStrings.push(item);
            }
          }
        }
        return extractedStrings;
      } else {
        console.error("Unexpected data structure:", result?.data);
        return [];
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
    return [];
  }
};

// to get hidden columns
export const getHiddenColumnsSampleCollector = async (
  data,
  setData,
  setLoading
) => {
  try {
    setLoading(true);
    const result = await axiosInstance.get(`v1/qc/get_hidden_fields`);
    console.log(result);
    if (result.data) {
      if (result.data.data && setData && typeof setData === "function") {
        const columnsData = result?.data?.data?.open_po;
        if (columnsData && Object.keys(columnsData).length > 0) {
          const hiddenColumns = columnsData.reduce((acc, columnName) => {
            acc[columnName] = false;
            return acc;
          }, {});
          setData(hiddenColumns);
        } else {
          console.log("Columns data is empty.");
          setData({});
        }
      }
    }
  } catch (error) {
    logout_if_403(error);
    console.error(getErrorMessage(error));
    const err = getErrorMessage(error);
    console.log({ error: err });
  } finally {
    setLoading(false);
  }
};
